import { render, staticRenderFns } from "./orderUsp.vue?vue&type=template&id=01645fc8&scoped=true&"
import script from "./orderUsp.vue?vue&type=script&lang=js&"
export * from "./orderUsp.vue?vue&type=script&lang=js&"
import style0 from "./orderUsp.vue?vue&type=style&index=0&id=01645fc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01645fc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01645fc8')) {
      api.createRecord('01645fc8', component.options)
    } else {
      api.reload('01645fc8', component.options)
    }
    module.hot.accept("./orderUsp.vue?vue&type=template&id=01645fc8&scoped=true&", function () {
      api.rerender('01645fc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/afterSale/sendNewDetail/comp/orderUsp.vue"
export default component.exports